
import { getPath } from '@/router/common'

const baseUrl = {
  title: '通讯中心',
  path: 'SMSPlatform'
}
export default [
  {
    path: getPath('AddressBook', baseUrl),
    name: 'AddressBook',
    component: () => import(/* webpackChunkName: "AddressBook" */ '@/views/smsPlatform/addressBook/index.vue'),
    meta: {
      title: '地址簿'
    }
  },
  {
    path: getPath('SMSOperation', baseUrl),
    name: 'SMSOperation',
    component: () => import(/* webpackChunkName: "SMSOperation" */ '@/views/smsPlatform/smsOperation/index.vue'),
    meta: {
      title: '短信推送'
    }
  },
  {
    path: getPath('BindWeChat', baseUrl),
    name: 'BindWeChat',
    component: () => import(/* webpackChunkName: "BindWeChat" */ '@/views/smsPlatform/bindWeChat/index.vue'),
    meta: {
      title: '微信绑定'
    }
  },
  {
    path: getPath('TelOperation', baseUrl),
    name: 'TelOperation',
    component: () => import(/* webpackChunkName: "TelOperation" */ '@/views/smsPlatform/telOperation/index.vue'),
    meta: {
      title: '定义短信电话'
    }
  },
  {
    path: getPath('smsRecord', baseUrl),
    name: 'SMSRecord',
    component: () => import(/* webpackChunkName: "SMSRecord" */ '@/views/smsPlatform/smsRecord/index.vue'),
    meta: {
      title: '短信记录'
    }
  },
  {
    path: getPath('weixinOperation', baseUrl),
    name: 'WeixinOperation',
    component: () => import(/* webpackChunkName: "WeixinOperation" */ '@/views/smsPlatform/weixinOperation/index.vue'),
    meta: {
      title: '微信绑定'
    }
  }
]
